// @todo: Migrate to 'Checkbox' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Checkbox} from '@wandb/weave/components';
// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tooltip} from '@wandb/weave/components/Tooltip';
import React from 'react';

// eslint-disable-next-line import/no-cycle -- please fix if you can
import {CHECKBOX_STYLE} from '../../../../components/StorageFileBrowser';

export const TableCheckbox = ({
  checked,
  onCheckedChange,
  disabled,
  onTableHeader = false,
}: {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  onTableHeader?: boolean;
}) => {
  const checkboxElement = (
    <Checkbox checked={checked} size="small" disabled={disabled} />
  );

  return (
    <div
      data-test="checkbox"
      className={CHECKBOX_STYLE}
      onClick={e => {
        e.stopPropagation();
        onCheckedChange(!checked);
      }}
      onKeyDown={e => {
        if (e.key === 'Enter') {
          e.stopPropagation();
          onCheckedChange(!checked);
        }
      }}>
      {onTableHeader ? (
        <Tooltip
          trigger={checkboxElement}
          content="Select all on current page"
        />
      ) : (
        checkboxElement
      )}
    </div>
  );
};
